<script lang="ts">
  import type { CompanyTeamMember } from "$lib/datamodel";
  import * as Card from "$lib/components/ui/card";
  import * as Avatar from "$lib/components/ui/avatar";
  import JsonLD from "$lib/components/JsonLD.svelte";
  import { page } from "$app/stores";
  export let blogAuthor: CompanyTeamMember;
  export let mode: "landingpage" | "blogpage";

  let jsonldPerson: any;

  if (blogAuthor) {
		jsonldPerson = {
				"@context": "http://schema.org",
				"@type": "Person",
				"name": `${blogAuthor.firstname} ${blogAuthor.lastname}`,
				"url": `${$page.url.origin}/blogs/authors/${blogAuthor.authorUrl}`,
				"image": blogAuthor.img,
				"jobTitle": blogAuthor.title,
				"affiliation": {
          "@type": "Organization",
          "name": "Nucamp Vibe Coding Bootcamp"
        },
				"email": blogAuthor.email,
				"sameAs": [] as string[],
				"worksFor": {
						"@type": "Organization",
						"name": "Nucamp Vibe Coding Bootcamp",
						"url": "https://www.nucamp.co"
				}
		}
		if (blogAuthor.linkedin) jsonldPerson.sameAs.push(blogAuthor.linkedin);
		if (blogAuthor.twitter) jsonldPerson.sameAs.push(blogAuthor.twitter);
  }
</script>

{#if mode === "blogpage"}
  <Card.Root class="rounded-sm mx-3 mb-8 md:mx-0 md:mb-0 dark:bg-slate-700">
    <Card.Header class="pb-4">
      <div class="flex flex-grow-0 justify-between">
        <div class="flex flex-row">
          <Avatar.Root>
            <Avatar.Image src="{blogAuthor.img}" alt="{blogAuthor.firstname} {blogAuthor.lastname} Blog Author for Nucamp" />
            <Avatar.Fallback>N</Avatar.Fallback>
          </Avatar.Root>
          <div class="flex flex-col ml-4">
            <Card.Title><a href="{$page.url.origin}/blogs/authors/{blogAuthor.authorUrl}?page=1" class="text-nucamp-primary underline underline-offset-2 decoration-dotted hover:text-nucamp-secondary">{blogAuthor.firstname} {blogAuthor.lastname}</a></Card.Title>
            <Card.Description>{blogAuthor.title}</Card.Description>
          </div>
        </div>
        <div>
          {#if blogAuthor.linkedin}
            <a href="{blogAuthor.linkedin}" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-linkedin"></ion-icon>
            </a>
          {/if}
          {#if blogAuthor.twitter}
            <a href="{blogAuthor.twitter}" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-twitter"></ion-icon>
            </a>
          {/if}
        </div>
      </div>
    </Card.Header>
    <Card.Content>
      <p class="text-sm border-t-2 pt-4">{blogAuthor.bio}</p>
    </Card.Content>
  </Card.Root>
{/if}
{#if mode === "landingpage"}
  {#if jsonldPerson}
      <JsonLD jsonLD={jsonldPerson}/>
  {/if}
  <Card.Root class="mx-3 mb-8 md:mx-0 md:mb-0 bg-slate-100 dark:bg-slate-700 border-none shadow-none">
    <Card.Header class="pb-4">
      <div class="flex flex-grow-0 justify-between">
        <div class="flex flex-row">
          <Avatar.Root class="h-16 lg:h-32 w-auto">
            <Avatar.Image src="{blogAuthor.img}" alt="{blogAuthor.firstname} {blogAuthor.lastname} Blog Author for Nucamp" />
            <Avatar.Fallback>N</Avatar.Fallback>
          </Avatar.Root>
          <div class="flex flex-col ml-4">
            <Card.Title tag="h1" class="text-2xl lg:text-4xl font-bold">{blogAuthor.firstname} {blogAuthor.lastname}</Card.Title>
            <Card.Description class="text-lg lg:text-2xl">{blogAuthor.title}</Card.Description>
            <div class="text-xl mt-auto">
              {#if blogAuthor.linkedin}
                <a href="{blogAuthor.linkedin}" target="_blank" rel="noopener noreferrer">
                  <ion-icon name="logo-linkedin"></ion-icon>
                </a>
              {/if}
              {#if blogAuthor.twitter}
                <a href="{blogAuthor.twitter}" target="_blank" rel="noopener noreferrer">
                  <ion-icon name="logo-twitter"></ion-icon>
                </a>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </Card.Header>
    <Card.Content>
      <p class="text-md lg:text-lg lg:pt-4">{blogAuthor.bio}</p>
    </Card.Content>
  </Card.Root>
{/if}

